import axios from "axios";
import WriteToLog from "./WriteToLog";   

/**
 * Get data from EHR at patient level
 * @param {*} patFHIRID 
 * @param {*} ehrID 
 * @param {*} fhir_server 
 * @param {*} access_token 
 * @returns 
 */
async function getObservationPatientData(patFHIRID, ehrID, fhir_server, access_token) {
  let ehrValue = "";
  const ehrconfig = await axios.get('ehrconfig.json');
  let config = ehrconfig.data[fhir_server];
  let code = config.EHR_SYSTEM_OID + '|' + ehrID;
  let observationSearchUrl = ehrconfig.data["EHR_OBSERVATION_SEARCH_R4"];
  let getObservationPatientDataUrl = fhir_server + observationSearchUrl + '?category=smartdata&code=' + encodeURIComponent(code) + '&patient=' + patFHIRID;

  try {
    let response = await axios.get(
      getObservationPatientDataUrl,
      { 
        headers: 
        {
          'Authorization': 'Bearer ' + access_token,
          'Accept': 'application/json'
        }
      });
      //WriteToLog("getObservationPatientData Observation.Search (R4) FHIR response: " + JSON.stringify(response.data));
      if (response.data.total > 0) {
        let entryArray = response.data.entry;
        for (var i=0; i < entryArray.length; i++) {
          if (entryArray[i].resource !== undefined) {
            let resourceType = entryArray[i].resource.resourceType;
            //WriteToLog("Resource Type: " + resourceType);
            if (resourceType === "Observation" && entryArray[i].resource.code !== undefined) {
              let code = entryArray[i].resource.code.coding[0].code;
              //WriteToLog("Code: " + code);
              if (code === ehrID) {
                if (entryArray[i].resource.component !== undefined) {
                  ehrValue = entryArray[i].resource.component[0].valueString;
                }
              }
            }
          }
        }
        return ehrValue;
      } else {
        //ehr value empty if total is 0
        return ehrValue;
      }
  } catch (error) {
    WriteToLog("getObservationPatientData Observation.Search FHIR error: " + error.message);
    return null;
  }
}

export default getObservationPatientData;
